export const Report = ({ color = "#FF2C2C", size = 34 }: { color?: string; size?: number } = {}) => {
    return (
        <svg width={size} height={size} viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.08301 29.7503V5.66699H19.833L20.3997 8.50033H28.333V22.667H18.4163L17.8497 19.8337H9.91634V29.7503H7.08301Z" fill={color} />
        </svg>

    )
}
